import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon, CalendarIcon, ClockIcon, RefreshCwIcon } from 'lucide-react';
interface RescheduleViewingModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (data: {
    date: string;
    time: string;
    reason: string;
  }) => void;
  viewing: any;
}
export function RescheduleViewingModal({
  isOpen,
  onClose,
  onSubmit,
  viewing
}: RescheduleViewingModalProps) {
  const [date, setDate] = useState('');
  const [time, setTime] = useState('');
  const [reason, setReason] = useState('');
  const handleSubmit = () => {
    if (!date || !time) {
      alert('Te rog completează data și ora noii programări');
      return;
    }
    onSubmit({
      date,
      time,
      reason
    });
    setDate('');
    setTime('');
    setReason('');
  };
  return <AnimatePresence data-id="element-5441">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50" data-id="element-5442" />

          {/* Modal */}
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        type: 'spring',
        damping: 25,
        stiffness: 300
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-5443">
            <div className="bg-white rounded-2xl shadow-2xl max-w-lg w-full overflow-hidden" data-id="element-5444">
              {/* Header */}
              <div className="bg-gradient-to-r from-orange-500 to-amber-600 text-white px-6 py-5" data-id="element-5445">
                <div className="flex items-center justify-between" data-id="element-5446">
                  <div className="flex items-center space-x-3" data-id="element-5447">
                    <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center backdrop-blur-sm" data-id="element-5448">
                      <RefreshCwIcon className="w-6 h-6" data-id="element-5449" />
                    </div>
                    <div data-id="element-5450">
                      <h3 className="text-xl font-bold" data-id="element-5451">
                        Reprogramează Vizionare
                      </h3>
                      <p className="text-sm text-orange-100" data-id="element-5452">
                        {viewing?.clientName} - {viewing?.propertyId}
                      </p>
                    </div>
                  </div>
                  <button onClick={onClose} className="p-2 hover:bg-white/20 rounded-lg transition-colors" data-id="element-5453">
                    <XIcon className="w-6 h-6" data-id="element-5454" />
                  </button>
                </div>
              </div>

              {/* Content */}
              <div className="p-6 space-y-4" data-id="element-5455">
                {/* Current Schedule */}
                <div className="bg-orange-50 border-l-4 border-orange-500 p-4 rounded-r-xl" data-id="element-5456">
                  <p className="text-sm font-bold text-orange-900 mb-1" data-id="element-5457">
                    Programare Curentă
                  </p>
                  <div className="flex items-center space-x-4 text-sm text-orange-700" data-id="element-5458">
                    <div className="flex items-center space-x-1" data-id="element-5459">
                      <CalendarIcon className="w-4 h-4" data-id="element-5460" />
                      <span data-id="element-5461">{viewing?.date}</span>
                    </div>
                    <div className="flex items-center space-x-1" data-id="element-5462">
                      <ClockIcon className="w-4 h-4" data-id="element-5463" />
                      <span data-id="element-5464">{viewing?.time}</span>
                    </div>
                  </div>
                </div>

                {/* New Date & Time */}
                <div data-id="element-5465">
                  <label className="block text-sm font-medium text-slate-700 mb-2" data-id="element-5466">
                    Nouă Dată *
                  </label>
                  <input type="date" value={date} onChange={e => setDate(e.target.value)} className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent" data-id="element-5467" />
                </div>

                <div data-id="element-5468">
                  <label className="block text-sm font-medium text-slate-700 mb-2" data-id="element-5469">
                    Nouă Oră *
                  </label>
                  <input type="time" value={time} onChange={e => setTime(e.target.value)} className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent" data-id="element-5470" />
                </div>

                <div data-id="element-5471">
                  <label className="block text-sm font-medium text-slate-700 mb-2" data-id="element-5472">
                    Motiv Reprogramare (opțional)
                  </label>
                  <textarea value={reason} onChange={e => setReason(e.target.value)} rows={3} placeholder="ex: Client indisponibil, Proprietar solicită altă dată..." className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent resize-none" data-id="element-5473" />
                </div>
              </div>

              {/* Footer */}
              <div className="bg-slate-50 px-6 py-4 flex items-center justify-between border-t border-slate-200" data-id="element-5474">
                <button onClick={onClose} className="px-5 py-2.5 rounded-xl font-semibold text-slate-700 hover:bg-slate-200 transition-colors" data-id="element-5475">
                  Anulează
                </button>
                <button onClick={handleSubmit} className="px-6 py-2.5 rounded-xl font-bold bg-gradient-to-r from-orange-500 to-amber-600 text-white hover:shadow-lg hover:scale-105 transition-all" data-id="element-5476">
                  Confirmă Reprogramare
                </button>
              </div>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}